// animation image start
function handleIntersection(entries, observer) {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
          setTimeout(function () {
            if (!entry.target.classList.contains('animation')) {
                entry.target.classList.add('animation');
            }
          }, 900 );
        } else {
            if (entry.target.classList.contains('animation')) {
                entry.target.classList.remove('animation');
            }
        }
    });
}

const observer = new IntersectionObserver(handleIntersection, {
    root: null, 
    rootMargin: '0px', 
    threshold: 0.1 
});
const sections = document.querySelectorAll('.animate_section');
sections.forEach(section => {
    observer.observe(section);
});
// animation image end

